import { GenericInput } from './GenericInput';
import React, { InputHTMLAttributes } from 'react';
import { Theme } from '@app/theme';
import { createUseStyles, useTheme } from 'react-jss';
import classnames from 'classnames';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  containerClass?: string;
  value: any;
  name?: string;
  error?: string;
  onChange: (value: any) => void;
  onClear: () => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    border: `1px solid ${theme.colors.grayBorder}`,
    borderRadius: theme.borderRadius.std,
    paddingInlineStart: theme.marginBase * 2,
    paddingInlineEnd: theme.marginBase,
    backgroundColor: theme.colors.white,
    height: theme.height.small,
  },
  input: {
    ...theme.fonts.caption,
    paddingBlock: 13,
    border: 'none',
    outline: 'none',
    backgroundColor: 'transparent',
    width: '100%',
    color: theme.colors.inkPrimary,

    '&::placeholder': {
      color: theme.colors.inkSecondary,
    },
  },
  searchIcon: {
    fontSize: theme.iconSize.regular,
    color: theme.colors.inkTertiary,
    marginRight: theme.marginBase,
  },
  clearIcon: {
    fontSize: theme.iconSize.regular,
    color: theme.colors.blue,
  },
}));

const SearchInputComponent = (props: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ ...props, theme });

  return (
    <div className={classnames(props.containerClass, classes.container)}>
      <i className={classnames(classes.searchIcon, 'ri-search-line')} />
      <input
        {...props}
        className={classnames(classes.input, props.className)}
        onChange={(e) => props.onChange(e.target.value)}
      />
      {props.value.length > 0 && (
        <button type="button" onClick={props.onClear}>
          <i className={classnames(classes.clearIcon, 'ri-close-line')} />
        </button>
      )}
    </div>
  );
};

export const SearchInput = (props: Props) => {
  return (
    <GenericInput
      type="text"
      {...props}
      noMargin
      small
      component={SearchInputComponent}
    />
  );
};
